'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMemo } from 'react';
import { css, useTheme } from 'styled-components';
import { STYLED_RESPONSIVE_BREAKPOINTS, } from '../../../../features/helpers/get-media-query-styling';
import styleToCss, { hasStyleValues, } from '../../../../features/helpers/style-to-css';
import { createFontSizeCSS } from '../../../../theme/global-style';
import { EllipsisStyling, FitContentStyling, getLineClampStyling, getStrikeStyling, } from '../styles';
const FigtreeFontItems = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
const useTypographyProps = (props) => {
    const theme = useTheme();
    return useMemo(() => {
        var _a, _b;
        const isFigtreeFont = FigtreeFontItems.includes((_a = props.elementTheme) !== null && _a !== void 0 ? _a : 'body1');
        const currentProps = {
            $default: css `
        ${createFontSizeCSS((_b = props.elementTheme) !== null && _b !== void 0 ? _b : 'body1', isFigtreeFont, props.bold
                ? 'bold'
                : props.medium
                    ? 'medium'
                    : isFigtreeFont
                        ? 'bold'
                        : 'regular')}
      `,
        };
        const prepareProps = (data, query) => {
            if (data) {
                const { bold, medium, strike, color, colorHover, underline, elementTheme, center, ellipsis, fitContent, nowrap, inline, font, lineClamp, overflow, normal, style, italic, textTransform, textAlign, letterSpacing, } = data;
                if (colorHover) {
                    currentProps[query] = css `
            ${currentProps[query]}
            &:hover {
              color: ${colorHover};
            }
          `;
                }
                if (elementTheme) {
                    const isFigtreeFont = FigtreeFontItems.includes(elementTheme);
                    currentProps[query] = css `
            ${currentProps[query]}
            ${createFontSizeCSS(elementTheme, isFigtreeFont, bold
                        ? 'bold'
                        : medium
                            ? 'medium'
                            : isFigtreeFont
                                ? 'bold'
                                : 'regular')}
          `;
                }
                if (nowrap) {
                    currentProps[query] = css `
            ${currentProps[query]}
            white-space: nowrap;
          `;
                }
                if (inline) {
                    currentProps[query] = css `
            ${currentProps[query]}
            display: inline-block;
          `;
                }
                if (underline) {
                    currentProps[query] = css `
            ${currentProps[query]}
            text-decoration: underline;
          `;
                }
                if (fitContent) {
                    currentProps[query] = css `
            ${currentProps[query]}
            ${FitContentStyling}
          `;
                }
                if (ellipsis) {
                    currentProps[query] = css `
            ${currentProps[query]}
            ${EllipsisStyling}
          `;
                }
                else if (overflow) {
                    currentProps[query] = css `
            ${currentProps[query]}
            overflow: hidden;
          `;
                }
                if (lineClamp) {
                    currentProps[query] = css `
            ${currentProps[query]}
            ${getLineClampStyling(lineClamp)}
          `;
                }
                if (bold) {
                    currentProps[query] = css `
            ${currentProps[query]}
            font-weight: ${theme.fontWeights.semibold};
          `;
                }
                else if (medium) {
                    currentProps[query] = css `
            ${currentProps[query]}
            font-weight: ${theme.fontWeights.medium};
          `;
                }
                else if (normal) {
                    currentProps[query] = css `
            ${currentProps[query]}
            font-weight: ${theme.fontWeights.regular};
          `;
                }
                if (font) {
                    currentProps[query] = css `
            ${currentProps[query]}
            font-family: ${font === 'inter'
                        ? theme.fontFamily.primary
                        : theme.fontFamily.secondary};
          `;
                }
                if (strike) {
                    currentProps[query] = css `
            ${currentProps[query]}
            ${getStrikeStyling(bold)}
          `;
                }
                if (italic) {
                    currentProps[query] = css `
            ${currentProps[query]}
            font-style: italic;
          `;
                }
                const fullStyle = Object.assign(Object.assign({}, (style !== null && style !== void 0 ? style : {})), { textTransform, textAlign: textAlign !== null && textAlign !== void 0 ? textAlign : (center ? 'center' : undefined), letterSpacing,
                    color });
                if (hasStyleValues(fullStyle)) {
                    currentProps[query] = css `
            ${currentProps[query]}
            ${styleToCss(fullStyle)}
          `;
                }
            }
        };
        const { children, onClick, onBlur, onMouseEnter, onMouseLeave, onPointerEnter, onPointerLeave, id, className } = props, defaultViewProps = __rest(props, ["children", "onClick", "onBlur", "onMouseEnter", "onMouseLeave", "onPointerEnter", "onPointerLeave", "id", "className"]);
        const defaultProps = {
            children,
            onClick,
            onMouseEnter,
            onMouseLeave,
            onPointerEnter,
            onPointerLeave,
            onBlur,
            id,
            className,
        };
        prepareProps(defaultViewProps, '$default');
        STYLED_RESPONSIVE_BREAKPOINTS.forEach((breakpoint) => {
            const breakpointProps = props[breakpoint];
            if (breakpointProps) {
                prepareProps(breakpointProps, `$${breakpoint}`);
            }
        });
        return { currentProps, defaultProps };
    }, [
        props,
        theme.fontFamily.primary,
        theme.fontFamily.secondary,
        theme.fontWeights.medium,
        theme.fontWeights.regular,
        theme.fontWeights.semibold,
    ]);
};
export default useTypographyProps;
